<template>
  <div class="container">
    <pre class="content">
      #&nbsp;I am what I am&nbsp;#
    </pre>
  </div>
</template>

<script>

export default {

}
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  font-family: KaiTi;
  padding: 30px;

  .content {
    line-height: 1.5em;
  }
}
</style>
